
import { FormEvent } from "react";
import { Button } from "@/components/ui/button";
import { ProfileImageSection } from "./ProfileImageSection";
import { BusinessNameField } from "./BusinessNameField";
import { CurrencySelect } from "./CurrencySelect";
import { MessagingPlatformSelect } from "./MessagingPlatformSelect";
import { PhoneNumberInput } from "./PhoneNumberInput";

interface SettingsDialogFormProps {
  isLoading: boolean;
  businessName: string;
  businessNameError: string;
  profileImage: string | null;
  isGeneratingName: boolean;
  selectedPrefix: string;
  phoneNumber: string;
  preferredMessaging: string;
  currency: string;
  fileInputRef: React.RefObject<HTMLInputElement>;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  onBusinessNameChange: (value: string) => void;
  onGenerateBusinessName: () => Promise<void>;
  onFileInputClick: () => void;
  onPrefixChange: (value: string) => void;
  onPhoneNumberChange: (value: string) => void;
  onPreferredMessagingChange: (value: string) => void;
  onCurrencyChange: (value: string) => void;
  onImageUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDeleteImage?: () => void;
}

export const SettingsDialogForm = ({
  isLoading,
  businessName,
  businessNameError,
  profileImage,
  isGeneratingName,
  selectedPrefix,
  phoneNumber,
  preferredMessaging,
  currency,
  fileInputRef,
  onSubmit,
  onBusinessNameChange,
  onGenerateBusinessName,
  onFileInputClick,
  onPrefixChange,
  onPhoneNumberChange,
  onPreferredMessagingChange,
  onCurrencyChange,
  onImageUpload,
  onDeleteImage,
}: SettingsDialogFormProps) => {
  return (
    <form onSubmit={onSubmit} className="space-y-6">
      <div className="space-y-4">
        <ProfileImageSection 
          profileImage={profileImage}
          fileInputRef={fileInputRef}
          onUploadClick={onFileInputClick}
          onImageUpload={onImageUpload}
          onDeleteImage={onDeleteImage}
        />

        <BusinessNameField 
          businessName={businessName}
          businessNameError={businessNameError}
          isGeneratingName={isGeneratingName}
          onBusinessNameChange={onBusinessNameChange}
          onGenerateBusinessName={onGenerateBusinessName}
        />

        <CurrencySelect 
          currency={currency}
          onCurrencyChange={onCurrencyChange}
        />

        <MessagingPlatformSelect 
          preferredMessaging={preferredMessaging}
          onPreferredMessagingChange={onPreferredMessagingChange}
        />

        <PhoneNumberInput 
          selectedPrefix={selectedPrefix}
          phoneNumber={phoneNumber}
          preferredMessaging={preferredMessaging}
          onPrefixChange={onPrefixChange}
          onPhoneNumberChange={onPhoneNumberChange}
        />
      </div>

      <Button 
        type="submit" 
        className="w-full bg-gradient-to-r from-gebeya-pink to-gebeya-orange hover:opacity-90 text-white"
        disabled={isLoading}
      >
        {isLoading ? "Saving..." : "Continue"}
      </Button>
    </form>
  );
};
